import { render, staticRenderFns } from "./protocolRecord.vue?vue&type=template&id=aae7b8a2"
import script from "./protocolRecord.vue?vue&type=script&lang=js"
export * from "./protocolRecord.vue?vue&type=script&lang=js"
import style0 from "./protocolRecord.vue?vue&type=style&index=0&id=aae7b8a2&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aae7b8a2')) {
      api.createRecord('aae7b8a2', component.options)
    } else {
      api.reload('aae7b8a2', component.options)
    }
    module.hot.accept("./protocolRecord.vue?vue&type=template&id=aae7b8a2", function () {
      api.rerender('aae7b8a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bulkyExpress/largePlaceOrderManagement/protocolRecord.vue"
export default component.exports